var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://apps.apple.com/us/app/empleat-app/id1590351073"}},[_c('img',{attrs:{"alt":"Get it on Google Play","height":_vm.height,"src":require("@/assets/apple-store-badge.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }